// project-imports
import support from './Menu';
// import catalogos from './Catalogos';
// import support from './support';
// import support from './support';

// types
import { NavItemType } from 'types/menu';

// ==============================|| MENU ITEMS ||============================== //

const menuItems: { items: NavItemType[] } = {
  items: [support]
};

export default menuItems;
